import CampaignSentIcon from '@/assets/images/icons/Camp-Email.svg';
import CampaignSmsSentIcon from '@/assets/images/icons/Camp-Sms.svg';
import SequenceProcessedIcon from '@/assets/images/icons/sequence-processed.svg';
import SequenceProcessingIcon from '@/assets/images/icons/sequence-processing-started.svg';
import SequenceStepCompletedIcon from '@/assets/images/icons/sequence-step-completed.svg';
import UserLeadCreatedIcon from '@/assets/images/icons/user-lead-created.svg';
import UserLeadUpdatedIcon from '@/assets/images/icons/user-lead-updated.svg';
import CampaignUnsubscribedIcon from '@/assets/images/icons/activity-logs/campaign-unsubscribed.svg';
import FormSubmittedIcon from '@/assets/images/icons/activity-logs/form-submitted.svg';
import AutomationProcessingStartedIcon from '@/assets/images/icons/activity-logs/automation-processing-started.svg';
import AutomationProcessedIcon from '@/assets/images/icons/activity-logs/automation-processed.svg';
import ContactAddedIntoListIcon from '@/assets/images/icons/activity-logs/contact-added-into-list.svg';
import ContactClickEmailLinkIcon from '@/assets/images/icons/activity-logs/contact-click-email-link.svg';
import ContactGetsTaggedIcon from '@/assets/images/icons/activity-logs/contact-gets-tagged.svg';
import ContactImportedIntoListIcon from '@/assets/images/icons/activity-logs/contact-imported-into-list.svg';
import ContactOpenEmailIcon from '@/assets/images/icons/activity-logs/contact-open-email.svg';
import ClickedLinkBroadcastEmailIcon from '@/assets/images/icons/activity-logs/clicked-link-broadcast-email.svg';
import ClickedLinkSequenceEmailIcon from '@/assets/images/icons/activity-logs/clicked-link-sequence-email.svg';
import ContactRemoveTagIcon from '@/assets/images/icons/activity-logs/contact-remove-tag.svg';
import ContactUnsubscribedIntoListIcon from '@/assets/images/icons/activity-logs/contact-unsubscribed-into-list.svg';
import OpenedBroadcastEmailIcon from '@/assets/images/icons/activity-logs/opened-broadcast-email.svg';
import OpenedSequenceEmailIcon from '@/assets/images/icons/activity-logs/opened-sequence-email.svg';
import EmailBouncedIcon from '@/assets/images/icons/activity-logs/email-bounced.svg';

export default {
  data() {
    return {
      // add this variable to map each icon with it's component
      componentMapping: {
        CampaignSentIcon,
        SequenceProcessingIcon,
        CampaignUnsubscribedIcon,
        FormSubmittedIcon,
        SequenceProcessedIcon,
        CampaignSmsSentIcon,
        AutomationProcessingStartedIcon,
        AutomationProcessedIcon,
        ContactAddedIntoListIcon,
        ContactClickEmailLinkIcon,
        ContactGetsTaggedIcon,
        ContactImportedIntoListIcon,
        ContactOpenEmailIcon,
        ContactRemoveTagIcon,
        ClickedLinkBroadcastEmailIcon,
        ClickedLinkSequenceEmailIcon,
        ContactUnsubscribedIntoListIcon,
        OpenedBroadcastEmailIcon,
        OpenedSequenceEmailIcon,
        UserLeadUpdatedIcon,
        UserLeadCreatedIcon,
        SequenceStepCompletedIcon,
        EmailBouncedIcon
      }
    };
  },

  components: {
    CampaignSentIcon,
    SequenceProcessingIcon,
    CampaignUnsubscribedIcon,
    FormSubmittedIcon,
    SequenceProcessedIcon,
    CampaignSmsSentIcon,
    AutomationProcessingStartedIcon,
    AutomationProcessedIcon,
    ContactAddedIntoListIcon,
    ContactClickEmailLinkIcon,
    ContactGetsTaggedIcon,
    ContactImportedIntoListIcon,
    ContactOpenEmailIcon,
    ContactRemoveTagIcon,
    ClickedLinkBroadcastEmailIcon,
    ClickedLinkSequenceEmailIcon,
    ContactUnsubscribedIntoListIcon,
    OpenedBroadcastEmailIcon,
    OpenedSequenceEmailIcon,
    UserLeadUpdatedIcon,
    UserLeadCreatedIcon,
    SequenceStepCompletedIcon,
    EmailBouncedIcon
  }
};
